import './PrintWindow.css';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PrintModal from './component/PrintModal';
import { Button } from 'primereact/button';

function PrintWindow(props) {
  const { t } = useTranslation();
  const [active, setActive] = useState(false);
  const btnRef = useRef();

  return (
    <div id="PrintWindow" className="PrintWindow">
      <Button
        className="HorizontalButton"
        type="button"
        alt={t('print.tooltip') || 'Impressão / Exportar'}
        title={t('print.tooltip') || 'Impressão / Exportar'}
        onClick={() => setActive(true)}
        ref={btnRef}
        icon="pi pi-print"
      >
      
      </Button>

      <PrintModal active={active} callback={setActive} map={props.map} />
    </div>
  );
}

export default PrintWindow;
